import { atom, useAtom } from "jotai";
import { ItemsGroup } from "types";
import { allItemGroups } from "constant-data/items";

export type ItemGroupsState = {
  activeItemsGroup: ItemsGroup | null;
};

type useItemGroupsReturn = {
  itemGroupsState: ItemGroupsState;
  setItemGroupsState: React.Dispatch<React.SetStateAction<ItemGroupsState>>;
};

export const itemsGroupAtom = atom<ItemGroupsState>({
  activeItemsGroup: allItemGroups,
});

export const useItemGroups = (): useItemGroupsReturn => {
  const [itemGroupsState, setItemGroupsState] = useAtom(itemsGroupAtom);

  return { itemGroupsState, setItemGroupsState };
};
